export const contactsData = {
  email: "bulbultomar14@gmail.com",
  phone: "+91-9754057360",
  address: "Indore , India  452001 ",

  // sheetAPI: "https://sheetdb.io/api/v1/0q0i70gypxuay",
};
